<template>
  <v-card flat color="transparent" class="py-1">
    <v-row>
      <v-col class="text-h5 font-weight-bold">
        {{ section.title }}
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto" class="font-weight-bold">
        {{ section.questions.length }} Questions
      </v-col>
    </v-row>
    <v-row v-if="section.description">
      <v-col cols="12">
        {{ section.description }}
      </v-col>
    </v-row>
    <v-divider class="mb-4 mt-2"></v-divider>
    <v-row v-for="(question, i) in section.questions" :key="i">
      <v-col cols="12">
        <annual-review-question
          :question="question"
          :section="section"
        ></annual-review-question>
      </v-col>
    </v-row>
    <v-divider v-if="!hideDivider" class="mt-4"></v-divider>
  </v-card>
</template>

<script>
import AnnualReviewQuestion from "@/components/annualreviews/AnnualReviewQuestion";
export default {
  name: "AnnualReviewSection",
  components: { AnnualReviewQuestion },
  props: {
    section: { type: Object },
    hideDivider: { type: Boolean, default: false }
  }
};
</script>
